export default "__VITE_ASSET__Bv86yjWx__"